export const formatIBAN = (val) => {
  if (!val || val.length < 19) {
    return 
  }
  val = val.replaceAll(' ', '')
  return (
    val.slice(0, 5) + ' ' + val.slice(5, 9) + ' ' + val.slice(9, 13) + ' ' + val.slice(13, 17) + ' ' + val.slice(17)
  )
}
